export const POS_PRINTERS_LOADING = "POS_PRINTERS_LOADING";
export const POS_PRINTERS_LIST = "POS_PRINTERS_LIST";
export const POS_PRINTERS_ERROR = "POS_PRINTERS_ERROR";
